import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const qualtrics = defineConnector({
  identifier: "qualtrics",
  name: "Qualtrics",
  tagLine: "Survey and experience management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*\\.qualtrics\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Qualtrics instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Qualtrics instance.",
        },
        {
          kind: "input",
          label: "Qualtrics Domain",
          placeholder: "domain",
          required: true,
          target: { kind: "configuration", field: "subdomain" },
          helperText:
            "The subdomain of your Qualtrics account (e.g. https://domain.qualtrics.com)",
        },
      ],
    },
    {
      title: "Create a Qualtrics app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Qualtrics Developer Portal](https://developer.qualtrics.com/) and navigate to **Account Settings → Qualtrics IDs** to set up your OAuth credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/qualtrics/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Qualtrics account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Qualtrics account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.subdomain}.qualtrics.com/oauth2/auth`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.subdomain}.qualtrics.com/oauth2/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.subdomain}.qualtrics.com/API/v3/whoami`,
  },
  publicEnvVars: ({ subdomain }) => ({
    QUALTRICS_URL: subdomain ? `https://${subdomain}.qualtrics.com` : "",
  }),
});
